import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import Seo from "../components/Seo";
import { CTA } from "../components/sections";
import { api } from "../lib/api";

export default function BlogArticle() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [nf, setNf] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setPost(null); setNf(false);
    api.get(`/content/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNf(true));
  }, [slug]);
  useEffect(() => { if (nf) navigate("/404", { replace: true }); }, [nf, navigate]);

  if (!post) return <div className="flex justify-center py-40"><Loader2 className="h-8 w-8 animate-spin text-brand-navy" /></div>;
  const seo = post.seo || {};
  const jsonLd = { "@context": "https://schema.org", "@type": "Article", headline: post.title, author: { "@type": "Organization", name: "Car To Cash" }, image: post.cover_image, datePublished: post.published_at };

  return (
    <>
      <Seo title={seo.meta_title || `${post.title} | Car To Cash`} description={seo.meta_description || post.excerpt} canonical={`https://cartocash.com.au/blog/${post.slug}`} jsonLd={jsonLd} />
      <article className="mx-auto max-w-3xl px-4 sm:px-6 py-12" data-testid="blog-article">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm font-bold text-brand-muted hover:text-brand-navy transition-colors"><ArrowLeft className="h-4 w-4" /> All articles</Link>
        <h1 className="mt-5 font-display text-4xl sm:text-5xl font-black leading-tight text-brand-navy">{post.title}</h1>
        <p className="mt-3 text-lg text-brand-muted">{post.excerpt}</p>
        <img src={post.cover_image} alt={post.title} className="mt-8 w-full rounded-2xl object-cover" />
        <div className="mt-8 space-y-5 text-lg leading-relaxed text-brand-navy">
          {(post.body || "").split("\n\n").map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </article>
      <CTA />
    </>
  );
}
